window.addEventListener('DOMContentLoaded', (event) => {
	
	

var txt = $(".okeReviews-reviewsSummary-ratingCount").children('span').first().text();
var txt = txt.substring(0, txt.indexOf(' '));
var txt = "("+ txt + ")";
$(".okeReviews-reviewsSummary-ratingCount").children('span').first().text(txt);

$(".tony_cart_modal_header").children("span").on('click', function(){
$(".tony_cart_modal_wrapper").addClass("hidden");
});

$(".tony_cart_modal_buttons_two").on('click', function(){
$(".tony_cart_modal_wrapper").addClass("hidden");
});

$(".tony_cart_modal_buttons_one").on('click', function(){
window.location.href = "/cart";

});





$('[data-action="add-to-cart"]').on('click', function(){
	

var variant_id = $("[name='id']").val();
var qty = $("[name='quantity']").val();
var check = $('input[type=radio].rc_widget__option__input--subsave:checked').length;


if ( check > 0) {
data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": $("[name='selling_plan']").val()
    }
var price = $(".rc_widget__price--subsave").text();
var delivery_legend = $("[name='selling_plan']").children('option:selected').text().toLowerCase().replace("delivery ",'').toUpperCase();;
} else {
data = {
      "id": variant_id,
      "quantity": qty

    }
var price = $(".ProductMeta__Price").text();



}
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
 
$(".tony_cart_modal_info_two_freq").children('span').text(delivery_legend);
$("#tony_qty_modal").text(qty);	  
$(".tony_cart_modal_info_three").children('span').text(price);
$(".tony_cart_modal_wrapper").removeClass("hidden");
      }
    });

});




});